import { InvoiceStatus } from '../types/invoice';

const getInvoiceStatusLabel = (status?: InvoiceStatus): string => {
    switch (status) {
        case 'pending':
            return 'Pendiente';
        case 'certified':
            return 'Certificada';
        case 'validationError':
            return 'Error de validación';
        case 'failed':
            return 'Error de sistema';
        case 'rejected':
            return 'Rechazada';
        case 'cancelled':
            return 'Anulada';
        default:
            return 'No disponible';
    }
};

export default getInvoiceStatusLabel;
